import LteInterface1Component from './components/lte-interface-1/lte-interface-1.component';
import LteInterface2Component from './components/lte-interface-2/lte-interface-2.component';
import routerConfig from './routes';

require('./lte.scss');

const moduleName = 'dmattnt-lte';
angular.module(moduleName, ['ui.router'])
  .component('dmattntLteInterface1', new LteInterface1Component())
  .component('dmattntLteInterface2', new LteInterface2Component())
  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/lte/lte.module.js